import { AfterViewInit, Component, ComponentFactoryResolver } from "@angular/core";
import { AppService } from "@api";
import { HeaderEnum, RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { DialogoEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { PeriodoEvaluacion } from "@modelo/proceso/periodoevaluacion.model";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";


@Component(
  {
      selector: 'administracionacuerdo',
      templateUrl: './administracionacuerdo.component.html',
      styleUrls: ['./administracionacuerdo.component.scss']
  })

export class AdministracionAcuerdoComponent implements AfterViewInit {

  consulta!: boolean;
  SelColaborador:any[] = [];
  listaperiodoevaluacion: any[] = [];
  entidad: PeriodoEvaluacion;
  periodoevaluacion: number = 0;

  constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){
    this.entidad = new PeriodoEvaluacion({});
  }

  ngAfterViewInit(): void {
    this.Periodoevaluacion();
  }

  Periodoevaluacion(){
    this.appService.Post("planeacion/periodoevaluacion/buscar",{}).then(res =>{
        if(res.status == RespuestaEstatusEnum.Success){
            this.listaperiodoevaluacion = res.data;
        }
    })
  }

  onRowPrepared(e:any){
    if(e.rowType == "data"){
      if(e.key.asignacionacuerdoresponsableid){
        e.rowElement.bgColor = "#D9EDF8";
      }
    }
    if (e.rowType === "group" && e.groupIndex == 0) {
        let grupos:any[] = e.data.items ? e.data.items : e.data.collapsedItems;
        e.data.total = grupos.length;
        let unicos = grupos.map(item => item.asignacionacuerdoresponsableid)
        .filter((value, index, self) => self.indexOf(value) === index && value != null);
        if(unicos.length > 0){
            e.data.texto = unicos.length + " agrupación de acuerdo";
        }else{
            e.data.texto = "Ninguna agrupación";
        }
    }
  }

  getAcuerdos(id:number){
    if(id){
      let entidad = this.listaperiodoevaluacion.find(x => x.periodoevaluacionid == id);
      this.entidad = entidad;
      this.appService.Post("acuerdo/asignacion/colaboradoracuerdoadmin",{"entidad":entidad}).then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
            this.SelColaborador = res.data;
        }
    })
    }else{
      this.SelColaborador = [];
      this.periodoevaluacion = 0;
    }
  }

  generarAcuerdos(){
    let opciones = this.sistemaService.GetOpcionesAceptar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', 'Se generarán los acuerdos para el periodo de evaluación seleccionado. Esta acción puede tardar varios minutos. Se recomienda no realizar ningún acuerdo ni modificar la pantalla actual. <br> ¿Desea continuar?', opciones).then(res => {
          if (res == 1) {
            this.appService.Get("acuerdo/asignacion/generaracuerdo/"+this.entidad.periodoevaluacionid, [HeaderEnum.NoShowLoading]).then(res=>{
            })
          }
      })

  }

  EliminarAcuerdo(entidad:any){
    let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Seguro de que deseas eliminar este acuerdo? <br> Si el o los acuerdos están agrupados, se eliminarán todos los acuerdos agrupados. <br> Esta acción es irreversible. <br> ¿Deseas continuar?', opciones).then(res => {
          if (res == 1) {
            this.appService.Post('acuerdo/asignacion/eliminaracuerdo', {"data":entidad}).then(res => {
              if(res.status == RespuestaEstatusEnum.Success){
                this.getAcuerdos(this.entidad.periodoevaluacionid);
              }
            });
          }
      })
  }

  EliminarGrupoAcuerdo(entidad:any){
    let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro de que quieres eliminar este grupo de acuerdos? <br> esta acción no se podrá deshacer.', opciones).then(res => {
          if (res == 1) {
            this.appService.Post('acuerdo/asignacion/eliminargrupoacuerdo', {"data":entidad}).then(res => {
              if(res.status == RespuestaEstatusEnum.Success){
                this.getAcuerdos(this.entidad.periodoevaluacionid);
              }
            });
          }
      })
  }

  EliminarAcuerdoGeneral(){
    let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro de que quieres eliminar todos los acuerdos? <br> esta acción no se podrá deshacer.', opciones).then(res => {
          if (res == 1) {
            this.appService.Post('acuerdo/asignacion/eliminaracuerdogeneral', {"periodo":this.entidad}).then(res => {
              if(res.status == RespuestaEstatusEnum.Success){
                this.getAcuerdos(this.entidad.periodoevaluacionid);
              }
            });
          }
      })
  }

}
